import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import GetApp from "@mui/icons-material/GetApp";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

export function DownDerateTrackerExportButton({ disabled, onClick }) {
  // if disabled, the tooltip will give you a warning that a disabled element does not fire events.
  return disabled ? (
    <ExportButton
      data-qa="DDT-Button-Export"
      variant="outlined"
      color="primary"
      aria-label="Down Derate Machines Export Button"
      disabled={disabled}
      onClick={onClick}
      startIcon={<GetApp />}
    >
      Export
    </ExportButton>
  ) : (
    <Tooltip
      title="Export all items from the down derate tracker in csv format."
      PopperProps={{
        "aria-label": "Down Derate Machines Export Button tooltip"
      }}
    >
      <ExportButton
        data-qa="DDT-Button-Export"
        variant="outlined"
        color="primary"
        aria-label="Down Derate Machines Export Button"
        disabled={disabled}
        onClick={onClick}
        startIcon={<GetApp />}
      >
        Export
      </ExportButton>
    </Tooltip>
  );
}

const ExportButton = styled(Button)`
  flex: 0 0 130px;
`;

DownDerateTrackerExportButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};
